const STORAGE_KEY = 'artonmain_quote';

// Additive, matching the "+ Add" button on /stocklist/ — adding a package twice doubles
// its quantities rather than replacing them. Unlike that button this does not skip
// priceless items: a package is curated, so silently dropping a line would leave the
// parent short. The build warns about any package item without a price instead.
export function mergeIntoQuote(quote, items) {
  const merged = quote.map(item => ({ ...item }));

  items.forEach(item => {
    const existing = merged.find(entry => entry.code === item.code);
    if (existing) {
      existing.qty += item.qty;
    } else {
      merged.push({
        code: item.code,
        description: item.description,
        price: item.price,
        qty: item.qty
      });
    }
  });

  return merged;
}

export function initPackages() {
  const buttons = document.querySelectorAll('.btn-add-package');
  const payload = document.getElementById('package-items');
  if (buttons.length === 0 || !payload) return;

  let items = [];
  try {
    items = JSON.parse(payload.textContent);
  } catch (e) {
    console.error('Failed to read package items:', e);
    return;
  }

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      let quote = [];
      try {
        quote = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        quote = [];
      }

      localStorage.setItem(STORAGE_KEY, JSON.stringify(mergeIntoQuote(quote, items)));
      window.location.href = '/stocklist/#quote';
    });
  });
}
